import React, { HTMLProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface FormLabelProps extends HTMLProps<HTMLLabelElement> {}

export const FormLabel = (props: FormLabelProps) => {
  const _className = twMerge('self-start font-semibold text-sm', props.className)

  return <label className={_className} {...props} />
}
